module.exports = __webpack_public_path__ + "31c017da02c964a448a7025ad0edf45f.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Arvo/Arvo-Regular.ttf
// module id = yBSq
// module chunks = 0